import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

interface Option<T> {
  label: string;
  value: T;
}
interface CareMapprRadioGroupProps<T> {
  label?: string | React.ReactNode;
  options: Option<T>[];
  selectedValue: T;
  onChange: (value: T) => void;
  controlId: string;
  className?: string;
  direction: 'vertical' | 'horizontal';
  onSpecialSelect?: (value: T) => void;
}

const CareMapprRadioGroup = <T,>({
  label,
  options = [],
  selectedValue,
  onChange,
  controlId = 'radioGroup',
  className = '',
  direction = 'vertical',
  onSpecialSelect,
}: CareMapprRadioGroupProps<T>) => {
  const handleChange = (value: string) => {
    let parsedValue: T;

    const firstOption = options[0]?.value;
    if (typeof firstOption === 'number') {
      parsedValue = Number(value) as T;
    } else if (typeof firstOption === 'boolean') {
      parsedValue = (value === 'true') as T;
    } else {
      parsedValue = value as T;
    }

    onChange(parsedValue);

    if (onSpecialSelect && parsedValue === ('specialOption' as T)) {
      onSpecialSelect(parsedValue);
    }
  };
  return (
    <Form.Group controlId={controlId} className={`mb-3 ${className}`}>
      {direction === 'vertical' ? (
        <Col>
          <Col xs={12}>
            {label && <Form.Label className="ellipsis">{label}</Form.Label>}
          </Col>
          <Col xs={12}>
            <div className="radio-container-col">
              {options.map((option, index) => (
                <Form.Check
                  className="roboto font-14"
                  key={index}
                  type="radio"
                  id={`${controlId}-${index}`}
                  name={controlId}
                  label={option.label}
                  value={String(option.value)}
                  checked={selectedValue === option.value}
                  onChange={(e) => handleChange(e.target.value)}
                />
              ))}
            </div>
          </Col>
        </Col>
      ) : (
        <Row>
          <Col xs={12} md={4}>
            {label && <Form.Label className="ellipsis">{label}</Form.Label>}
          </Col>
          <Col xs={12} md={8}>
            <div className="radio-container">
              {options.map((option, index) => (
                <Form.Check
                  key={index}
                  type="radio"
                  id={`${controlId}-${index}`}
                  name={controlId}
                  label={option.label}
                  value={String(option.value)}
                  checked={selectedValue === option.value}
                  onChange={(e) => handleChange(e.target.value)}
                />
              ))}
            </div>
          </Col>
        </Row>
      )}
    </Form.Group>
  );
};

export default CareMapprRadioGroup;
